
import Google_event from "app/tracking/google/event"
import Baidu_event from "app/tracking/baidu/event"
import Facebook_event from "app/tracking/facebook-pixel/event"
import PageInstance from "app/page_instance/index"
import GA4_Event from "app/tracking/google/google_analytics_4/event"
import {snakeCase} from "change-case"

const listing_type_label = (type: string) => {
  switch (type){
    case "residential_rent":
      return "Residential Rent"
    case "residential_sale":
      return "Residential Sale"
    case "commercial_rent":
      return "Commercial Rent"
    case "commercial_sale":
      return "Commercial Sale"
    case "serviced_apartment":
      return "Serviced Apartment"
    case "overseas":
      return "Overseas Property"
    default:
      return "Unknown"
  }
}


// region PropertyTypeLabels
// Define enum for flow properly
// https://github.com/facebook/flow/issues/5465#issuecomment-350422478
/* eslint-disable no-unused-vars */
enum PropertyTypeLabels {
  RESIDENTIAL_RENTAL  = "Residential Rental",
  RESIDENTIAL_SALE    = "Residential Sale",
  COMMERCIAL_RENTAL   = "Commercial Rental",
  COMMERCIAL_SALE     = "Commercial Sale",
  SERVICED_APARTMENT  = "Serviced Apartment",
  OVERSEAS            = "Overseas",

  //region Business Center

  BUSINESS_CENTER     = "Business Center",
  SERVICED_OFFICE     = "Serviced Office",
  COWORKING_SPACE     = "Coworking Space",

  //endregion

  COLIVING_SPACE      = "Coliving Space",
}
/* eslint-enable no-unused-vars */
// endregion PropertyTypeLabels




const ListingContactByPhone = {
  track: () => {
    Facebook_event.trackPhone()
  },
}

const ListingContactSuccessByPhone = {
  PropertyTypeLabels: PropertyTypeLabels,

  track(property_type_label: PropertyTypeLabels){
    // New tracking event for sent phone enquiries
    Google_event.track({
      category: PageInstance.currentPageNameForTracking(),
      action:   "Enquiry",
      options:  {
        eventLabel: `${property_type_label} Phone Enquiry - Submitted`,
      },
    })

    GA4_Event.track({
      event_name: "phone_enquiry_submitted",
      options:    {
        page:  PageInstance.currentPageNameForTracking(),
        label: snakeCase(property_type_label),
      },
    })

    Baidu_event.track({
      category: PageInstance.currentPageNameForTracking(),
      action:   "Enquiry",
      options:  {
        eventLabel: `${property_type_label} Phone Enquiry - Submitted`,
      },
    })
  },
}


// region ListingContactByEmail
const ListingContactByEmail = {
  PropertyTypeLabels: PropertyTypeLabels,

  track(property_type_label: PropertyTypeLabels){
    Facebook_event.trackEmail()

    // New tracking event for sent phone enquiries
    Google_event.track({
      category: PageInstance.currentPageNameForTracking(),
      action:   "Enquiry",
      options:  {
        eventLabel: `${property_type_label} Email Enquiry - Submitted`,
      },
    })

    GA4_Event.track({
      event_name: "email_enquiry_submitted",
      options:    {
        page:  PageInstance.currentPageNameForTracking(),
        label: snakeCase(property_type_label),
      },
    })

    Baidu_event.track({
      category: PageInstance.currentPageNameForTracking(),
      action:   "Enquiry",
      options:  {
        eventLabel: `${property_type_label} Email Enquiry - Submitted`,
      },
    })
  },
}
// endregion ListingContactByEmail


const MobileAppDownloadLead = {
  track(eventLabel: string){
    const category = "Mobile App Download Lead"
    const action = "App Store Link Opened"
    const options = {
      eventLabel,
      eventValue: 1,
    }
    Google_event.track({category, action, options})
    Baidu_event.track({category, action, options})
  },
}


export default {
  ListingContactByPhone,
  ListingContactSuccessByPhone,
  ListingContactByEmail,
  MobileAppDownloadLead,
}
